module.exports = __webpack_public_path__ + "img/Monk.033c9a1d.png";